module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_12.beda8272.png";